<template>
  <Layout>
    <div class="container-fluid h-100">
      <div class="row h-100">

        <!-- LEFT SIDE (md-4) -->
        <div class="col-md-4 d-flex flex-column gap-2">

          <!-- TOP -->
          <div class="card p-3 flex-fill">
            <div class="video-block">
              <LiveVideo :event="event"></LiveVideo>
            </div>
          </div>

          <!-- BOTTOM -->
          <div class="card p-3 flex-fill">
            <LiveEventStats :data="aggregateddata"></LiveEventStats>
          </div>

        </div>

        <!-- RIGHT SIDE (md-8) -->
        <div class="col-md-4">
          <div class="card p-3 h-100">
            <Details
              @disconnectAllUsers="disconnectAllUsers"
              @blockUserStatus="blockUser"
              :user="user"
              :moderators="moderators"
              :normalUsers="normalUsers"
            ></Details>
            <PollsSurvey
                        :event="event"
                        @triggerEvent="triggerPollEvents"
                        @disabledChat="disabledChat"
                        :cmes="cmes"
                    ></PollsSurvey>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card p-3 h-100">
            <template v-if="!isClicked">
                    <Chat
                        @blockuser="blockUser"
                        @setMessage="onDivInput"
                        @loadMessages="loadNewMessages"
                        @removeSelectedUser="removeSelectedUserMethod"
                        :messageLoading="messageLoading"
                        @removeMsg="deleteMessage"
                        :normalUsers="normalUsers"
                        :selectedUser="selected_user"
                        @setStar="setStarMessage"
                        :joined="joined_person"
                        :messages="messages"
                        :currentUser="user"
                    ></Chat>
                </template>
                <template v-else>
                    <DisplayResults
                        :event="event"
                        :cme_id="selectedCme"
                    ></DisplayResults>
                </template>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/modmain";
import MixinRequest from "../../../mixins/request";
import modratorMixin from "../../../mixins/ModuleJs/moderator";
import LiveVideo from "./live-video";
import LiveEventStats from "./live-event-stats";
import Details from "./details";
import PollsSurvey from "./polls-surveys";
import Chat from "./chat";
import DisplayResults from "./display-results";
// let ws = null;
export default {
  data() {
    return {
    }
  },
  mixins: [MixinRequest, modratorMixin],
  components: {
    Layout,
    LiveVideo,
    LiveEventStats,
    Details,
    PollsSurvey,
    Chat,
    DisplayResults
  },
};
</script>
